/**
 * @file ToastContainer.jsx
 * @description Portal-based container for toast notifications.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { useToast } from '../../../context/ToastContext';
import ToastItem from './ToastItem';
import './Toast.css';

/**
 * ToastContainer component that renders active toasts via React Portal.
 */
const ToastContainer = () => {
    const { toasts, removeToast } = useToast();

    // Render nothing if there are no toasts
    if (toasts.length === 0) return null;

    return ReactDOM.createPortal(
        <div className="toast-container">
            {toasts.map(toast => (
                <ToastItem 
                    key={toast.id} 
                    toast={toast} 
                    onRemove={removeToast} 
                />
            ))}
        </div>,
        document.body
    );
};

export default ToastContainer;
